import React from 'react';

import Text from '../../atoms/text/text';
import IconChevronRight from '../../atoms/icons/icon-chevron-right';
import { makeClassNames } from '../../../utils/styles';
import ImgPlaceholder from '../../atoms/img-placeholder/img-placeholder';
import './player-card-slim.scss';
import Cta from '../../atoms/cta/cta';

export interface IPlayerCardSlim {
  lastName: string;
  playerUrl?: string;
  playerPoints?: number;
  playerTeamName: string;
  imageUrl?: string;
  lazy?: boolean;
  trackingDataValue?: string;
}

const classNames = () => {
  return makeClassNames({
    player: 'player-card-slim',
    image: 'player-card-slim__image',
    wrapper: 'player-card-slim__wrapper',
    fullLink: 'player-card-slim__full-link',
    points: 'player-card-slim__points',
    uppercase: 'player-card-slim__text--uppercase',
    underlined: 'player-card-slim__text--underlined',
    score: 'player-card-slim__score',
    arrow: 'player-card-slim__arrow',
    info: 'player-card-slim__info',
  });
};

const PlayerCardSlim = (props: IPlayerCardSlim) => {
  const { lastName, playerUrl, playerPoints, playerTeamName, imageUrl, lazy = false, trackingDataValue } = props;

  const cn = classNames();

  const placeholderUrl =
    'https://static.sky.it/images/skysport/configurations/placeholders/football/SkySpport-player_placeholder.png';

  const playerImage = (
    <ImgPlaceholder
      src={lazy ? undefined : imageUrl}
      data-src={lazy ? imageUrl : undefined}
      placeholder={placeholderUrl}
      alt={lastName}
      title={lastName}
    />
  );

  return (
    <div className={cn.player}>
      <div className={cn.score}>
        <Text className={cn.uppercase} tag="span" fontSize="14" fontWeight="500" color="blue">
          GOL
        </Text>
        <Text className={cn.points} tag="span" fontSize="32--34" fontWeight="500" color="blue">
          {playerPoints}
        </Text>
      </div>
      <div className={cn.image}>{playerImage}</div>
      <div className={cn.info}>
        <Text tag="span" fontSize="16" fontWeight="500" color="blue" className={playerUrl ? cn.underlined : ''}>
          {lastName}
        </Text>
        <Text tag="span" fontSize="14" fontWeight="400" color="blue">
          {playerTeamName}
        </Text>
      </div>
      {playerUrl ? (
        <div className={cn.arrow}>
          <IconChevronRight size="xsmall" color="blue" />
        </div>
      ) : null}
      {playerUrl ? (
        <Cta
          href={playerUrl}
          aria-label={lastName}
          title={lastName}
          className={cn.fullLink}
          trackingData={trackingDataValue ? { intcmp: trackingDataValue } : undefined}
        />
      ) : null}
    </div>
  );
};

export default PlayerCardSlim;
